import { render, staticRenderFns } from "./NatureButton.vue?vue&type=template&id=a42c06f8&"
import script from "./NatureButton.vue?vue&type=script&lang=js&"
export * from "./NatureButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports